import type { ResourceGroup } from './oleshkyResources'

// Human Safari (Kherson) reporting, grouped by outlet, most recent outlet first. Shown in the Inform
// section of the Help page, like the Oleshky reporting on the left bank page.
export const humanSafariNews: ResourceGroup[] = [
  {
    title: 'Kyiv Post',
    links: [
      {
        label: '‘Unrestricted Permission to Kill’: Inside Kherson’s Drone War',
        href: 'https://www.kyivpost.com/interviews/85144',
        date: '27/09/2026',
      },
      {
        label: 'Ukraine Suffers More Civilian Deaths in 8 Months of 2026 Than All of 2025 – UN',
        href: 'https://www.kyivpost.com/post/84741',
        date: '17/09/2026',
      },
      {
        label: '‘Human Safari’: How Kherson Became a Hunting Ground for Russian Drones',
        href: 'https://www.kyivpost.com/post/83134',
        date: '28/08/2026',
      },
    ],
  },
  {
    title: 'The Chenab Times',
    links: [
      {
        label: 'Ukrainian City Endures Intense Shelling as US Peace Efforts Continue',
        href: 'https://thechenabtimes.com/2026/09/15/ukrainian-city-endures-intense-shelling-as-us-peace-efforts-continue/',
        date: '15/09/2026',
      },
    ],
  },
  {
    title: 'ABC News',
    links: [
      {
        label: "'The basement saved me': Frontline Ukrainian city under fire amid US peace push",
        href: 'https://abcnews.com/International/basement-saved-frontline-ukrainian-city-fire-amid-us/story?id=136336860',
        date: '15/09/2026',
      },
    ],
  },
  {
    title: 'Le Parisien',
    links: [
      {
        label: 'Kherson : dans l’enfer du « safari humain », l’appel pressant à l’évacuation',
        href: 'https://www.leparisien.fr/international/ukraine/kherson-dans-lenfer-du-safari-humain-lappel-pressant-a-levacuation-28-08-2026-D4MBX7JCB5HX7ALWCJZWKDTFDM.php',
        date: '28/08/2026',
      },
      {
        label: '"Safari humain" : la menace dépasse les frontières ukrainiennes',
        href: 'https://youtu.be/uf9WcKgw1ag',
        date: '13/08/2026',
      },
    ],
  },
  {
    title: 'Newsweek',
    links: [
      {
        label: 'Bombs, Bodies and Barbecues: Independence Day on Ukraine’s Frontline',
        href: 'https://www.newsweek.com/ukraine-independence-day-kherson-frontline-12359186',
        date: '28/08/2026',
      },
    ],
  },
  {
    title: 'France 24',
    links: [
      {
        label:
          '‘Not an isolated incident’: Russian drones stalk Ukraine’s civilians in ‘human safaris’',
        href: 'https://www.france24.com/en/europe/20260825-not-an-isolated-incident-russian-drones-stalk-ukraine-civilians-human-safaris',
        date: '25/08/2026',
      },
    ],
  },
  {
    title: 'The Sun',
    links: [
      {
        label:
          'Inside Ukraine’s eerie ‘drone tunnel’ where ‘human safari’ slaughter is so intense that kids learn how to save parents',
        href: 'https://www.thesun.co.uk/news/40083665/ukraine-drone-tunnel-slaughter-children-save-parents/',
        date: '23/08/2026',
      },
      {
        label:
          'How Russian public is paying drone pilots to carry out sick ‘human safari’ attacks on innocent Ukrainian civilians',
        href: 'https://www.thesun.co.uk/news/39973440/putin-human-safari-russia-ukraine-drone-war/',
        date: '08/08/2026',
      },
    ],
  },
  {
    title: 'Euromaidan Press',
    links: [
      {
        label:
          'Russia hunted civilians by drone in Kherson. Victims are suing the US firm they say helped connect the attackers',
        href: 'https://euromaidanpress.com/2026/08/15/russia-hunted-civilians-by-drone-in-kherson-victims-are-suing-the-us-firm-they-say-helped-connect-the-attackers/',
        date: '15/08/2026',
      },
      {
        label: 'In Kherson, the children still train under the drones',
        href: 'https://euromaidanpress.com/2026/07/31/khersons-bombed-out-boxers-asked-to-keep-russia-out-world-boxing-just-let-it-in/',
        date: '31/07/2026',
      },
    ],
  },
  {
    title: 'BILD',
    links: [
      {
        label: "Russia's manhunt can hit anyone at any time",
        href: 'https://www.bild.de/politik/ausland-und-internationales/human-safari-so-gezielt-macht-russland-mit-drohnen-jagd-auf-zivilisten-6a79b39de22753e756e9bb1d',
        date: '11/08/2026',
      },
    ],
  },
  {
    title: 'Times of India',
    links: [
      {
        label: 'Man & drone: On the battlefield, and off it, to attack civilians',
        href: 'https://timesofindia.indiatimes.com/blogs/toi-edit-page/man-drone-on-tthe-battlefield-and-off-it-to-attack-civilians/',
        date: '10/08/2026',
      },
      {
        label: "Drones hunting humans: Inside Russia's 'Human Safari' in Ukraine",
        href: 'https://timesofindia.indiatimes.com/toi-blogs/beyond-borders/drones-hunting-humans-inside-russias-human-safari-in-ukraine/articleshow/133068709.cms',
        date: '09/08/2026',
      },
    ],
  },
  {
    title: 'RFE/RL',
    links: [
      {
        label: "Ukrainians In Kherson 'Hunted' Daily By Russian Drones",
        href: 'https://www.rferl.org/a/ukraine-kherson-russian-drones-human-safari/33822793.html',
        date: '06/08/2026',
      },
    ],
  },
  {
    title: 'Byline Times',
    links: [
      {
        label: 'Two Years On, the World Witnesses Human Safari in Kherson',
        href: 'https://bylinetimes.com/2026/08/05/two-years-on-the-world-witnesses-human-safari-in-kherson/',
        date: '05/08/2026',
      },
      {
        label: "Russian Drones Set Fire to Ukraine's Agricultural Heartland",
        href: 'https://www.bylinesupplement.com/p/russian-drones-set-fire-to-ukraines',
        date: '09/07/2026',
      },
    ],
  },
  {
    title: 'The Atlantic',
    links: [
      {
        label: 'Putin’s Human Safari Is the Dystopian Future of War',
        href: 'https://www.theatlantic.com/ideas/2026/08/ukraine-russia-war-drones/688183/?gift=hVZeG3M9DnxL4CekrWGK39caRyLWbez08zFBsWDwWOM',
        date: '05/08/2026',
      },
    ],
  },
  {
    title: 'Fox News',
    links: [
      {
        label:
          "Terrifying 'human safaris' on display in shocking video that reveals depths of Russia's deadly campaign",
        href: 'https://www.foxnews.com/world/terrifying-human-safaris-display-shocking-video-reveals-depths-russias-deadly-campaign',
        date: '05/08/2026',
      },
    ],
  },
  {
    title: 'taz',
    links: [
      {
        label: 'Menschenjagd mit Drohnen',
        href: 'https://taz.de/Krieg-in-der-Ukraine/!6201922/',
        date: '05/08/2026',
      },
    ],
  },
  {
    title: 'Reuters',
    links: [
      {
        label:
          'Ukraine accuses Russia of war crime after video shows drone attacking vegetable seller in Kherson',
        href: 'https://www.reuters.com/world/europe/ukraine-accuses-russia-war-crime-after-video-shows-drone-hunting-market-vendor-2026-08-04/',
        date: '04/08/2026',
      },
    ],
  },
  {
    title: 'BBC',
    links: [
      {
        label: "Ukrainian vegetable seller targeted in 'human safari' drone attack",
        href: 'https://www.bbc.com/news/videos/clye173d533o',
        date: '04/08/2026',
      },
    ],
  },
  {
    title: 'The Times',
    links: [
      {
        label: 'Russian drone hounds Ukrainian market vendor in ‘human safari’',
        href: 'https://www.thetimes.com/world/russia-ukraine-war/article/russia-targeting-civilians-drone-chases-man-bh2znkxlc',
        date: '04/08/2026',
      },
    ],
  },
  {
    title: 'New York Post',
    links: [
      {
        label:
          'Russian drone hunts, taunts street vendor in Ukraine’s ‘human safari zone’ in disturbing video',
        href: 'https://nypost.com/2026/08/04/world-news/russian-drone-hunts-taunts-street-vendor-in-ukraines-human-safari-zone/',
        date: '04/08/2026',
      },
    ],
  },
]
